import { Injectable, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as xlsx from 'xlsx';
import * as FileSaver from 'file-saver';

@Injectable()
export class ExcelService {
  private readonly datePipe = inject(DatePipe);

  async generateExcel(info, fileName, fileExtension, excelType) {
    const wscols = [
      { wch: 10 },
      { wch: 10 },
      { wch: 50 },
      { wch: 30 },
      { wch: 30 },
      { wch: 50 }
    ];
    const worksheet = xlsx.utils.json_to_sheet(info); // Data for export
    worksheet['!cols'] = wscols;
    const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = xlsx.write(workbook, {
      bookType: fileExtension,
      type: 'array'
    });
    this.saveAsExcelFile(excelBuffer, fileName, fileExtension, excelType);
  }

  saveAsExcelFile(
    buffer: any,
    fileName: string,
    fileExtension: string,
    excelType: string
  ): void {
    const dateTime = this.datePipe
      .transform(Date.now(), 'ddMMyyyy HHmm')
      .toString();
    const EXCEL_EXTENSION = `.${fileExtension}`;
    const data: Blob = new Blob([buffer], { type: excelType });
    FileSaver.saveAs(data, fileName + dateTime + EXCEL_EXTENSION);
  }
}
